import BackboneElement from './BackboneElement';
import EncounterChanges from './EncounterChanges';
import merge from 'lodash/merge';

export default class EncounterHistory extends BackboneElement {
    static __className = 'EncounterHistory';

    __objectStructure = {
        dateOfService: String,
        placeOfService: String,
        procedureCode: String,
        unit: Number,
        modifier: String,
        auth: String,
        payer: String,
        renderingProvider: String,
        credentials: String,
        NPI: String,
        changedBy: String,
        timestamp: String,
        changes: [EncounterChanges],
    };

    constructor(constructJson, className = 'EncounterHistory') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
